import React from 'react';
import PropTypes from 'prop-types';
import TTRowsOptions from '../ttRowsOptions/TTRowsOptions';
import TTListItemInput from './c/ttListItemInput/TTListItemInput';
import LinearProgress from 'material-ui/LinearProgress';

class TTManageMappingList extends React.Component {
  state = {
    acceptedFiles: []
  };

  handleAddLineClick = () => this.props.ttActions.createMatchColListItem(this.props.sourceInputId);

  handleValueBlur = (id, value) => this.props.ttActions.updateMatchColListItem(id, value, this.props.sourceInputId);

  handleItemDelete = id => this.props.ttActions.deleteMatchColListItem(id, this.props.sourceInputId);

  handleUploadTTListItems = newAcceptedFiles => {
    const { sourceInputId, ttActions } = this.props;
    this.setState(oldState => ({ acceptedFiles: [ ...oldState.acceptedFiles, ...newAcceptedFiles ] }));
    const additionalInformation = { matchColumnId: sourceInputId };
    ttActions.uploadFileTTListItems(newAcceptedFiles, additionalInformation, sourceInputId);
  };

  render() {
    const { listItems, fetchingTranslationTableData } = this.props;
    return (
      <React.Fragment>
        <TTRowsOptions
          onAddLineClick={ this.handleAddLineClick }
          style={ { width: 500 } }
          onDropAccepted={ this.handleUploadTTListItems }
        />
        <div className={ 'tt-mapping-list-items' }>
          { 
            fetchingTranslationTableData &&
            <LinearProgress mode="indeterminate" />
          }
          
          {
            listItems && !fetchingTranslationTableData &&
            listItems.items.map(({ id, matchValue }) => (
              <TTListItemInput 
                id={ id } 
                key={ id } 
                onBlur={ this.handleValueBlur } 
                onDelete={ this.handleItemDelete } 
                value={ matchValue }
              />
            )) 
          }
        </div>
        <hr style={ { marginTop: 100, borderColor: '#ccc' } } />
      </React.Fragment>
    );
  }
}

TTManageMappingList.propTypes = {
  sourceInputId: PropTypes.number.isRequired,
  listItems: PropTypes.object,
  tableId: PropTypes.number,
  ttActions: PropTypes.shape({
    createMatchColListItem: PropTypes.func,
    updateMatchColListItem: PropTypes.func,
    deleteMatchColListItem: PropTypes.func,
    uploadFileTTListItems: PropTypes.func
  }).isRequired,
  fetchingTranslationTableData: PropTypes.bool.isRequired
};

export default TTManageMappingList;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttManageMappingList/TTManageMappingList.js